import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

import { exportIconButtonSx } from '@components/common/IconButton/styles';

import { ExportActiveSvg, ExportSvg } from '@assets';
import { IconButtonTooltip } from '@components';

interface IExportIcon {
  isDisabled: boolean;
  onHandleClick: () => void;
}

export const ExportIcon = ({ isDisabled, onHandleClick }: IExportIcon) => {
  const { t } = useTranslation();

  return (
    <IconButtonTooltip
      disableInteractive
      title="common.grid.button.tooltip.export.orbit"
    >
      <Box component="span" sx={{ display: 'inline-flex' }}>
        <IconButton
          disableRipple
          aria-label={t('common.grid.button.tooltip.export.orbit')}
          color="inherit"
          disabled={isDisabled}
          onClick={onHandleClick}
          sx={exportIconButtonSx}
        >
          <ExportSvg className="icon-default" />
          <ExportActiveSvg className="icon-active" />
        </IconButton>
      </Box>
    </IconButtonTooltip>
  );
};
